module.exports = __webpack_public_path__ + "static/media/Resume.200b14dc.pdf";